import getGpsAdaptor from '@/lib/getGps';
import { useEffect, useState, useCallback, useRef } from 'react';

export default () => {
  const [gps, setGps] = useState<{
    lat: number;
    lng: number;
  }>();
  const [gpsResult, setGpsResult] = useState<'success' | 'fail'>();
  const gpsResultRef = useRef<'success' | 'fail'>();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (gpsResultRef.current) {
        return;
      }
      gpsResultRef.current = 'fail';
      setGpsResult('fail');
    }, 5000);
    getGpsAdaptor()
      .then(gpss => {
        if (gpsResultRef.current) {
          return;
        }
        gpsResultRef.current = 'success';
        setGpsResult('success');
        setGps(gpss);
        clearTimeout(timer);
        // setGps({
        //   lng: 103.821219,
        //   lat: 1.352672,
        // });
        // refGps.current = {
        //   lng: 103.821219,
        //   lat: 1.352672,
        // };
      })
      .catch(err => {
        setGpsResult('fail');
        gpsResultRef.current = 'fail';
        clearTimeout(timer);
      });
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return { gps, gpsResult };
};
